import React from 'react'

const ProgressBar = ({ currentQuestion, totalQuestions }) => {
    const message = `Question ${currentQuestion} of ${totalQuestions}`
    const percentComplete = (currentQuestion / totalQuestions) * 100

    return (
        <div className="cell small-12 large-8 large-offset-2 progress-container">
            <p className="bold">{message}</p>

            <div className="progress progress-bar" role="progressbar" tabIndex="0" aria-valuenow={`${percentComplete}`} aria-valuemin="0" aria-valuetext={message} aria-valuemax="100">
                <div className="progress-meter" style={{width: percentComplete + '%'}}></div>
            </div>
        </div>
    )
}

export default ProgressBar


// WEBPACK FOOTER //
// ./src/components/ProgressBar.js